import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { getLocalEvents, LocalEvent } from 'core/API/local-events';
import './LocalEvents.scss';

interface LocalEventsProps {
	workplaceId?: number | null;
	className?: string;
}

/**
 * Reusable component for displaying local events
 * Fetches events based on workplace ID
 */
export const LocalEvents: React.FC<LocalEventsProps> = ({ workplaceId, className = '' }) => {
	const [localEvents, setLocalEvents] = useState<LocalEvent[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchLocalEvents = async () => {
			if (!workplaceId) return;

			setLoading(true);
			try {
				const events = await getLocalEvents(workplaceId);
				setLocalEvents(events);
			} catch (error) {
				console.error('Error fetching local events:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchLocalEvents();
	}, [workplaceId]);

	if (loading) {
		return (
			<div className="loading-container">
				<CircularProgress size={20} />
			</div>
		);
	}

	if (localEvents.length === 0) {
		return <p>No local events found</p>;
	}
	// console.log('Local Events:', localEvents);

	return (
		<div className={`local-events ${className}`}>
			{localEvents.map((event) => (
				<div key={event.id} className="event-card">
					<div className="event-title">{event.title}</div>
					<p>
						{event.date?.slice(0, 10)} {event.time} {event.timezone}
					</p>
					{event.why_hot && <p className="why-hot">{event.why_hot}</p>}
					{(event.sport || event.broadcast) && (
						<p className="broadcast">{event.sport || event.broadcast}</p>
					)}
					<p>
						{event.city}, {event.country}
					</p>
				</div>
			))}
		</div>
	);
};
